import { render, staticRenderFns } from "./ai-image-text-recognition-modal.vue?vue&type=template&id=171affaa&"
import script from "./ai-image-text-recognition-modal.vue?vue&type=script&lang=ts&"
export * from "./ai-image-text-recognition-modal.vue?vue&type=script&lang=ts&"
import style0 from "./ai-image-text-recognition-modal.vue?vue&type=style&index=0&id=171affaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.0_css-loader@6.11.0_webpack@5.111.1__lodash@4.18.1_vue-template-compiler@2.7.16_webpack@5.111.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports